interface Options {
  locale?: string
}

export function formatNumber(number: number, options?: Options) {
  const formatter = new Intl.NumberFormat(options?.locale || 'et-EE')
  return formatter.format(number)
}

export function formatPrice(price: number, options?: Options) {
  const formatter = new Intl.NumberFormat(options?.locale || 'et-EE', {
    currency: 'EUR',
    style: 'currency',
  })
  return formatter.format(price)
}

export function formatPercent(percent: number, options?: Options) {
  const formatter = new Intl.NumberFormat(options?.locale || 'et-EE', {
    style: 'percent',
  })
  return formatter.format(percent / 100)
}
